
<ng-container [formGroup]="form">
  <div class="row mt-2">
    <div class="form-group col-auto">
      <label>Support Contact</label>
      <div class="input-group">
        <div class="custom-control custom-radio custom-control-inline">
          <input type="radio" id="reviewerSupportRadio" [value]="true" formControlName="reviewerIsSupportContact" class="custom-control-input">
          <label class="custom-control-label" for="reviewerSupportRadio">Reviewer</label>
        </div><!-- END: custom-control-->
        <div class="custom-control custom-radio custom-control-inline">
          <input type="radio" id="entitySupportRadio" [value]="false" formControlName="reviewerIsSupportContact" class="custom-control-input">
          <label class="custom-control-label" for="entitySupportRadio">{{entityLabel}} </label>
        </div><!-- END: custom-control-->
      </div>
    </div>
    <div class="col mt-3">
      <div class="text-muted s_txt-xs">REVIEWER: Reviewer is shown as response contact to the serving party</div>
      <div class="text-muted s_txt-xs">{{entityLabel.toUpperCase()}}: User specified below is shown as response contact to the serving party</div>
    </div>
  </div>
  @if (!reviewerIsSupportContact) {
    <div class="row mt-3">
      <div class="form-group col-md-6 ">
        <label>Response Contact Name</label>
        <input id="company-entity-edit-response-contact-name" formControlName="deliveryPortalContactName" type="text" class="form-control">
      </div><!-- END: form-group -->
      <div class="form-group col-md-6">
        <label>Response Contact Email</label>
        <input id="company-entity-edit-response-contact-email" formControlName="deliveryPortalContactEmail" type="text" placeholder="example@email.com" class="form-control">
      </div><!-- END: form-group -->
      <div class="form-group col-md-6">
        <label>Invoice Contact Name</label>
        <input id="company-entity-edit-invoice-contact-name" formControlName="invoiceContactName"  type="text" class="form-control">
      </div><!-- END: form-group -->
      <div class="form-group col-md-6">
        <label>Invoice Contact Email</label>
        <input id="company-entity-edit-invoice-contact-email" formControlName="invoiceContactEmail" type="text" placeholder="example@email.com" class="form-control">
      </div><!-- END: form-group -->
    </div>
  }
</ng-container>